/*******************************************************************************************************************
 *************************************************API插件安装******************************************************
 ********************************************************************************************************************/
import $api from './api';
//if(!__DEBUG__){
//	//非DEBUG模式下不显示控制台打印信息
//	var cons = function(){ };
//	window.console = {
//		log: cons,
//		warn: cons,
//		info: cons,
//		error: cons,
//	};
//}else{
//	console.log('%cVue%cdeveloper : 覃登,%cEmail : qindeng1993@foxmail.com',
//	'color:white;font-size:2rem;font-family:STLITI;background:#3184FF;padding:0 10px;border-radius:3px 0 0 3px; ',
//	'color:white;font-size:2rem;font-family:STLITI;background:#393D49;padding:0 20px;',
//	'color:white;font-size:2rem;font-family:STLITI;background:#009688;padding:0 10px;border-radius:0 3px 3px 0; ')
//	console.log('%c温馨提示：大家都是成年人了，有什么事直接找我们的程序员小哥就好了,！^_^',
//	'color:red;font-size:1.5rem;font-family:华文行楷;background:#2F4056;padding:0 10px;border-radius: 5px;')
//}

const install = function(Vue, opts = {}) {
	if(install.installed) return;
	Vue.prototype.$http = $api;
};

// auto install
if(typeof window !== 'undefined' && window.Vue) {
	install(window.Vue);
}

export default {
	version: process.env.VERSION, // eslint-disable-line no-undef
	install,
};

//module.exports.default = module.exports = nApi; // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./src/api/index.js